import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { name: String }

  clear() {
    document.cookie = `${ this.nameValue }=; path=/; max-age=0`
  }
}
